<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="materialDbmSKUs"
        @reset="resetHandle"
        @addOrEdit="addEditHandle"
        @select="selectHandle">
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" label-width="65px" @keyup.enter.native="loadData(1)">
            <el-form-item label="物料号">
              <el-input v-model.trim="filter.materialNos" placeholder="支持输入多行" clearable type="textarea"/>
            </el-form-item>
            <el-form-item label="水位回补检索" label-width="120px">
              <el-select v-model="filter.waterLevel" clearable>
                <el-option label="<0最低水位回补" value="0"/>
                <el-option label="<0最高水位回补" value="1"/>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template slot="otherBtn">
        <el-upload
            action=""
            :http-request="importFile"
            :show-file-list="false"
            style="float: left; margin-right: 4px;">
          <el-button type="primary" :loading="importLoading">导入模板</el-button>
        </el-upload>
        <el-button
            type="primary"
            plain
            icon="el-icon-download"
            @click="downloadModel">
          模板下载
        </el-button>
        <span style="color: red">
          红色文字表示90天内实际库存未发生变化  只自动更新近三个月内创建的物料库存</span>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button type="success" :loading="scope.row.loading1" @click="refreshStockReserve(scope.row)">
          同步SAP数据
        </el-button>
      </template>
    </view-table>
    <edit-page ref="editPage" @save-success="loadData"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import EditPage from "@/views/PurchaseOrderManager/MaterialDbmSku/MaterialDbmSkuEdit";
  import loginUtil from "@/util/loginUtil";


  export default {
    name: "MaterialDbmSkuList",
    components: {ViewTable,EditPage},
    data() {
      return {
        importLoading:false,
        limits: {
          editAuth: this.$auth(7),
          subAuth: this.$auth(8),
          creatDeliveryAuth: this.$auth(135),
        },
        filter: {
          materialNos:"",
          waterLevel:"",
        },
        columnsProperty: [
          {
            key: "materialNO",
            width: 130,
            align: "center",
          },
          {
            key: "action",
            width: 250,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },

    watch: {
      "filter.deliveryBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.deliveryDateRange = [];
            this.deliveryDateRange.push(this.filter.deliveryBeginDate);
            this.deliveryDateRange.push(this.filter.deliveryEndDate);
          }
        },
      },
      "filter.orderBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.createDateRange = [];
            this.createDateRange.push(this.filter.orderBeginDate);
            this.createDateRange.push(this.filter.orderEndDate);
          }
        },
      },
      "filter.submitBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.submitDateRange = [];
            this.submitDateRange.push(this.filter.submitBeginDate);
            this.submitDateRange.push(this.filter.submitEndDate);
          }
        },
      },
    },

    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },


      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      addEditHandle(row) {
        console.log(row);
        this.$refs.editPage.open(row.pkId);
      },

      refreshStockReserve(row) {
        row.loading1 = true;
        this.$http.get("basic", "sapSyn/stock?materialNo=" + row.materialNO)
          .then((resp) => {
            if (resp.success) {
              this.loadData();
              this.$message.success("库存/预留获取成功");
            }
          })
          .finally(() => {
            row.loading1 = false;
          });
      },

      rowStyle({row}) {
        if (row.stockChangeOverMonth) {
          return {
            color: "red",
            fontWeight: "bold",
          };
        }
      },

      //下载导入模板
      downloadModel() {
        window.open("/file/原材料库存管理导入模板.xlsx");
      },

      //导入
      importFile(params) {
        this.importLoading = true;
        let formData = new FormData();
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http.post("basic", "materialDbmSKUs/importExcel", formData).then((res) => {
          if (res.success) {
            this.$message.success("导入成功");
            this.loadData();
          } else {
            this.$message.error("导入失败");
          }
        }).catch(() => {
          this.$message.error("导入失败");
        }).finally(() => {
          this.importLoading = false;
        });
      },

      
    },
  };
</script>
